import SpinnerCircle from "@/components/spinner"
import { Button as ShadButton } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { MouseEvent, useEffect, useState } from "react"

export type ButtonProps = Omit<
  React.ComponentProps<typeof ShadButton>,
  "onClick"
> & {
  isLoading?: boolean
  onClick?: (e: MouseEvent<HTMLButtonElement>) => Promise<void> | void
}

export default function Button({
  children,
  disabled,
  className,
  variant,
  isLoading,
  onClick,
  ...props
}: ButtonProps) {
  const [localIsLoading, setLocalIsLoading] = useState(false)

  useInit()

  function useInit() {
    useEffect(() => {
      setLocalIsLoading(isLoading || false)
    }, [isLoading])
  }

  async function handleClick(e: MouseEvent<HTMLButtonElement>) {
    try {
      if (onClick) {
        setLocalIsLoading(true)
        await onClick(e)
      }
    } finally {
      setLocalIsLoading(false)
    }
  }

  return (
    <ShadButton
      className={cn("relative", className)}
      type="button"
      disabled={localIsLoading || disabled}
      variant={variant}
      onClick={handleClick}
      {...props}
    >
      {children}

      {localIsLoading && (
        <div
          className={cn(
            `
              absolute h-full w-full rounded-lg flex items-center
              justify-center
            `,
            (variant === "default" || !variant) &&
              localIsLoading &&
              "bg-button-disabled",
            variant === "outline" && localIsLoading && "bg-white"
          )}
        >
          <SpinnerCircle
            variant={variant === "default" || !variant ? "dark" : "light"}
          />
        </div>
      )}
    </ShadButton>
  )
}
